/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import L from "../Lang"
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import RegisterCard from "./RegisterCard";
import Wallet from "./Wallet";

class Checkout extends BaseCom {
    constructor(props) {
        super(props);
        const months = [];
        const years = [];
        for (let n = 1; n <= 12; n++)
            months.push({ id: n, name: n });

        var y = new Date().getFullYear();
        for (let n = y; n <= (y + 20); n++)
            years.push({ id: n, name: n });

        this.state = {
            info: {},
            months: months,
            years: years,
            paymentMethodList: []
        };
    }

    loadPaymentMethods = async () => {
        try {
            let j = await qreq.getAsync('/api/card/list');
            if (j.list)
                this.setState({ paymentMethodList: j.list });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    selectPaymentMethod = (paymentMethod) => {
        this.setState({ selectedPaymentMethod: { ...paymentMethod } })
    }

    success = () => {
        this.setState({ success: true });
    }

    submit = async (e) => {
        e?.preventDefault();
        if (!this.state.selectedPaymentMethod)
            return;
        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/checkout', {
                purchaseOrderID: this.props.params.poID,
                paymentMethodID: this.state.selectedPaymentMethod.id
            });

            if (j.errorCode === 0)
                this.success();
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    render() {
        return (<div className="container-fluid">
            <h1><L>Checkout</L></h1>
            {this.state.success ? <div className="alert alert-success"><L>Payment successful, you will receive a receipt via email.</L></div>
                : this.state.paymentMethodList.length === 0
                    ? <RegisterCard onSuccess={this.loadPaymentMethods} /> : <Wallet onSelect={this.selectPaymentMethod} />}
        </div>);
    }
}

export default withParamsAndNavigate(Checkout);